import type { VideoTutorialsProps } from '../model/types'

import { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'

import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from '@/shared/components/ui/sheet'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'

const VideoTutorialsPanel = lazy(() =>
	import('./VideoTutorialsPanel').then((module) => ({
		default: module.VideoTutorialsPanel,
	}))
)

export function VideoTutorials({ children, tags }: VideoTutorialsProps) {
	const { t } = useTranslation()

	return (
		<Sheet
			onOpenChange={(open) => {
				if (!open) {
					ampli.videoTutorialsClose({
						tags,
					})
				} else {
					ampli.videoTutorialsOpen({
						tags,
					})
				}
			}}
		>
			<Tooltip>
				<TooltipTrigger asChild>
					<SheetTrigger asChild>{children}</SheetTrigger>
				</TooltipTrigger>
				<TooltipContent>
					{t('video_tutorials.tooltip', { defaultValue: 'Help' })}
				</TooltipContent>
			</Tooltip>
			<SheetContent className='inset-y-2 right-2 h-auto min-w-lg rounded-3xl border backdrop-blur-xl'>
				<SheetHeader className='pb-0'>
					<SheetTitle>
						{t('video_tutorials.title', { defaultValue: 'Help' })}
					</SheetTitle>
					<SheetDescription className='sr-only'>
						{t('video_tutorials.description', {
							defaultValue:
								'There are some videos that can help you to understand how to use the app.',
						})}
					</SheetDescription>
				</SheetHeader>
				<Suspense fallback={<div>Loading...</div>}>
					<VideoTutorialsPanel tags={tags} />
				</Suspense>
			</SheetContent>
		</Sheet>
	)
}
